// components/secure/ClientCmaPanel.js — the seller's CMAs on the client record (feature #4).
// Lists the comparative market analyses linked to this client (the server applies agentScope +
// recordAccess) and starts a new one with the client's address as the subject.
// API: GET /api/cma?client_id= (routes/cma.js); the builder is /dashboard/cma.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useApiClient } from '../../hooks/useApiClient';
import { getCurrentUser } from '../../hooks/useCurrentUser';

const money = (v) => (v === null || v === undefined ? '—' : `$${Math.round(Number(v)).toLocaleString('en-US')}`);

export default function ClientCmaPanel({ clientId }) {
    const api = useApiClient();
    const user = getCurrentUser();
    const [rows, setRows] = useState(null);
    useEffect(() => {
        api.get(`/api/cma?client_id=${Number(clientId)}`).then(setRows).catch(() => setRows(null));
    }, [api, clientId]);
    if (rows === null || user?.role === 'examiner') return null;
    return (
        <div className="bg-white p-4 sm:p-8 rounded-lg shadow">
            <div className="flex flex-wrap justify-between items-center gap-2 mb-3">
                <h2 className="text-xl font-bold text-slate-800">Comparative Market Analyses</h2>
                <Link to={`/dashboard/cma?new=1&client_id=${Number(clientId)}`} className="px-3 py-1 rounded text-sm bg-slate-800 text-white hover:bg-slate-700">New CMA for this client</Link>
            </div>
            <p className="text-xs text-slate-500 mb-2">Broker price opinions prepared for this seller (not appraisals).</p>
            {rows.length === 0 ? <p className="text-sm text-slate-500">None yet.</p> : (
                <ul className="divide-y text-sm">
                    {rows.map((r) => (
                        <li key={r.cma_id} className="py-2 flex flex-wrap justify-between gap-2">
                            <Link className="text-indigo-700 underline" to={`/dashboard/cma?id=${r.cma_id}`}>{r.title}</Link>
                            <span className="text-slate-600">{money(r.recommended_price)} · {r.status}{r.current_version ? ` · v${r.current_version}` : ''} · {new Date(r.updated_at).toLocaleDateString()}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
